import { render, staticRenderFns } from "./lottery-coupon-card.vue?vue&type=template&id=99047e40&scoped=true&"
import script from "./lottery-coupon-card.vue?vue&type=script&lang=js&"
export * from "./lottery-coupon-card.vue?vue&type=script&lang=js&"
import style0 from "./lottery-coupon-card.vue?vue&type=style&index=0&id=99047e40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99047e40",
  null
  
)

export default component.exports